import React from 'react'
import { GeckoComponentDataFrame, GeckoInspection } from 'types'

import { ImagesLayerSelect } from './ImagesLayerSelect'
import {
  ISAssetVizInputSelectRow,
  ISStyledSelectDiv,
  ISStyledSelectLabel,
} from './StyledComponents'

interface CDFSelectorProps {
  componentDataFrames: readonly GeckoComponentDataFrame[]
  selectedInspection: GeckoInspection
  selectedCDF: GeckoComponentDataFrame | null
  setSelectedCDF: (cdf: GeckoComponentDataFrame | null) => void
}

export const CDFSelector = ({
  componentDataFrames,
  selectedInspection,
  selectedCDF,
  setSelectedCDF,
}: CDFSelectorProps) => {
  const handleCDFChange = (value: string) => {
    const selected = componentDataFrames.find((cdf) => cdf.id === value)
    setSelectedCDF(selected || null)
  }

  const filteredCDFs = componentDataFrames.filter(
    (cdf) =>
      selectedInspection &&
      cdf.tags?.inspection?.includes(selectedInspection.id)
  )

  const cdfOptions = filteredCDFs.map((cdf) => cdf.id)

  return (
    <ISAssetVizInputSelectRow>
      <ISStyledSelectDiv>
        <ISStyledSelectLabel>Data&nbsp;Layer:</ISStyledSelectLabel>
        <ImagesLayerSelect
          label='Data Layer'
          options={cdfOptions}
          value={selectedCDF?.id || ''}
          onChange={handleCDFChange}
        />
      </ISStyledSelectDiv>
    </ISAssetVizInputSelectRow>
  )
}
